/**
 * iOS WebView only opens the native keyboard when focus happens inside an
 * active user gesture. A delayed `el.focus()` after `nextTick` falls outside
 * that window — the input gets focus but the keyboard never appears, and the
 * sheet ends up with empty space where the keyboard should be.
 *
 * The workaround: focus a temporary input first (still inside the gesture)
 * to "claim" the keyboard, then transfer focus to the real input after a
 * short delay so the cursor lands in the right place.
 *
 * The temp input is placed using viewport-relative coordinates from
 * `getBoundingClientRect()` rather than `offsetTop` / `offsetLeft`, because
 * the bottom sheet animates with `transform: translateY(...)` and contains
 * absolutely-positioned chip layers — `offsetTop`/`offsetLeft` would yield
 * positions relative to those ancestors, while `position: fixed` interprets
 * coordinates against the viewport.
 */
export const focusAndOpenKeyboard = (el?: HTMLInputElement, timeout = 100) => {
  if (!el) {
    return;
  }

  const rect = el.getBoundingClientRect();
  const tempInput = document.createElement('input');
  tempInput.style.position = 'fixed';
  tempInput.style.top = `${rect.top + 7}px`;
  tempInput.style.left = `${rect.left}px`;
  tempInput.style.height = '0px';
  tempInput.style.opacity = '0';
  document.body.appendChild(tempInput);
  tempInput.focus();

  setTimeout(() => {
    el.focus();
    el.click();
    document.body.removeChild(tempInput);
  }, timeout);
};
